import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import UiPill from 'garaje/components/ui-pill';
import NavLink from 'garaje/pods/components/nav-link/component';
import type GlobalOverviewAccessService from 'garaje/services/global-overview-access';
import LiquidIf from 'liquid-fire/components/liquid-if';

interface GlobalEmployeesSignature {
  Args: {
    isEmployeesOpen: boolean;
    trackClickEvent: (trackingString: string) => void;
  };
}

export default class GlobalEmployees extends Component<GlobalEmployeesSignature> {
  @service declare globalOverviewAccess: GlobalOverviewAccessService;

  <template>
    {{! Gate on canVisitGlobalEmployees alone — canVisitGlobalGroups implies it, so there's no groups-only state. }}
    {{#if this.globalOverviewAccess.canVisitGlobalEmployees}}
      <li>
        {{! Header navigates to the directory but its current-when is false so it never self-highlights — the "All
            employees" child carries aria-current. aria-expanded + the LiquidIf collapse mirror the sibling
            sections: the sub-list is open only while a location-overview.employees route is active. }}
        <NavLink
          @route="location-overview.employees"
          @current-when={{false}}
          class="icon-mainNav-employees flex font-bold py-2"
          aria-expanded={{if @isEmployeesOpen "true" "false"}}
          {{on "click" (fn @trackClickEvent "SideBar-Global-Employees")}}
          data-test-nav-employees-header
        >
          Employees
        </NavLink>
        <LiquidIf @predicate={{@isEmployeesOpen}}>
          <ul class="list-none m-0 leading-normal ml-4 mb-1 p-1 pl-2" data-test-nav-employees>
            {{! "All employees" always shows here — the outer gate already guarantees canVisitGlobalEmployees. }}
            <li>
              <NavLink
                @route="location-overview.employees"
                @current-when="location-overview.employees.directory location-overview.employees.sync-settings location-overview.employees.scim-settings location-overview.employees.integrations"
                class="block p-2"
                {{on "click" (fn @trackClickEvent "SideBar-Global-EmployeeDirectory")}}
                data-test-nav-link-employee-directory
              >
                All employees
              </NavLink>
            </li>
            {{#if this.globalOverviewAccess.canVisitGlobalGroups}}
              <li>
                <NavLink
                  @route="location-overview.employees.groups"
                  class="block p-2"
                  {{on "click" (fn @trackClickEvent "SideBar-Global-EmployeeGroups")}}
                  data-test-nav-link-employee-groups
                >
                  Groups
                  <UiPill @fill="newLightBlue" class="ml-2" data-test-groups-beta-pill>BETA</UiPill>
                </NavLink>
              </li>
            {{/if}}
          </ul>
        </LiquidIf>
      </li>
    {{/if}}
  </template>
}
